export default class ControlJsonReader {
    read(json) {
        const c = {};
        c.code = json.c;
        c.name = json.n;
        c.type = json.t;
        return c;
    }
}
